import $ from 'jquery';
export default {
    name: 'liste-societe',
    components: {},
    props: [],
    data() {
        return {
            fields: [
                { key: 'index', label: 'N°' }, { key: 'nom', label: 'Nom de la societé' }, 
                { key: 'secteur', label: 'Secteur d\'activités '}, 'certifications',
                { key: 'type_contrat', label: 'Type de contrat' },
                { key: 'debut_contrat', label: 'Debut de contrat' },
                { key: 'fin_contrat', label: 'Fin de contrat' }, { key: 'actions', label: 'Action.s' },
            ],
            filter: "",
            tableIsBusy: true,
            perPage: 10,
            currentPage: 1,

            loading: true
        }
    },
    computed: {
        rows() {
            return 0;
        },

        /**
         * Récupérer la liste des sociétés
         */
        societes() {
            return this.$store.getters['societes']
        },

    },
    mounted() {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        // recupération de la liste des societés
        this.$store.dispatch("getSocietes").then(
            (response) => {
                this.tableIsBusy = false;
                console.log("soc", response)
                this.loading = false

                setTimeout(() => {
                    $('.shw').fadeIn()
                }, 500);
            }
        )
    },
    methods: {


        formatDateDDMMYYY: function(given_date) {
            let date = new Date(given_date)
            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = '0' + month
            if (day < 10) day = '0' + day
            let date_to_return = `${day}/${month}/${date.getFullYear()}`;
            return date_to_return
        }
    }
}